import '/assets/styles/pages/smf/map.scss';

// Partials
import Img from '@wearetla/tla-essentials-tools/partials/img';

// Static Assets
import image_map from '/assets/images/wallet-instructions/map.jpg';

const SMFMap = () => {
	return (
		<div className="wrapper">
			<Img src={image_map} className="map-image" alt="Alan Krokisi" />
		</div>
	);
};

export default SMFMap;
